<script>
export default {
  data: () => ({
    id: 0,
    examResult: null,
    answerPaperPicture: null,
    isLoading: false,
  }),

  created() {
    this.id = Number(this.$route.params.id);
    this.init();
  },

  methods: {
    async init() {
      this.isLoading = true;
      this.examResult = await this.$axios.$get(`/admin/result/${this.id}`);
      if (this.examResult.answerId) {
        if (this.examResult.keldi == 1) {
          const url = `/admin/application/exam/file/${this.examResult.answerId}`;
          this.answerPaperPicture = await this.$axios.$getImage(url);
        }
      }
      this.isLoading = false;
    },

    getName(item) {
      return item?.name;
    },
  },
};
</script>

<template>
  <v-container v-if="examResult" fluid>
    <div class="pt-5">
      <h2>Imtihon natijalari</h2>

      <div class="-wrap">
        <v-row>
          <v-col cols="12" lg="6" class="pr-lg-0">
            <div class="my-card">
              <h4 class="text-center">
                2022 YIL TEST SINOVLARI NATIJALARI BO'YICHA UMUMIY MA'LUMOT
              </h4>
              <div class="pt-4">
                To'liq ismi: <b>{{ examResult.fullName }}</b>
              </div>
              <div class="pt-4">
                Test sinovlarida umumiy to'plagan balli:
                <b>{{ examResult.completedBall }}</b>
              </div>
              <div v-if="examResult.keldi == 1">
                <div class="pt-4" v-if="examResult.result == 1">
                  <b> Talabalikka tavsiya etilgan ta'lim yo'nalishi:</b>
                  {{ examResult.actxt }}
                </div>

                <div class="pt-4" v-else>
                  <b> Talabalikka tavsiya etilmadi </b>
                </div>
              </div>
              <div class="pt-4" v-else>
                <b> Qatnashmagan </b>
              </div>

              <v-divider class="mt-4" />
              <div class="pt-4">
                Institut nomi:
                <b>TOSHKENT SHAHRIDAGI YEOJU TEXNIKA INSTITUTI</b>
              </div>
              <table class="w-100 mt-5">
                <tbody>
                  <tr>
                    <td>
                      Maxsus kodi: <b>{{ examResult.answerId }}</b>
                    </td>
                    <td>
                      Ta'lim shakli:
                      <b>{{ getName(examResult.educationType) }}</b>
                    </td>
                    <td>
                      Ta'lim tili:
                      <b>{{ getName(examResult.educationLanguage) }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Imtihon sanasi: <b>{{ examResult.day }}</b>
                    </td>
                    <td>
                      Smena: <b>{{ examResult.smena }}</b>
                    </td>
                    <td>
                      Guruh raqami: <b>{{ examResult.group }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>

              <v-divider class="mt-4" />
              <div v-if="examResult.educationType.id == 1">
                <h4 class="text-center py-5">TEST TOPSHIRGAN FANLAR</h4>

                <v-divider />

                <div class="pt-4">
                  Savollar kitobi raqami:
                  <b>{{ examResult.questionBookNumber }}</b>
                </div>

                <v-divider class="mt-4" />

                <div v-if="examResult.fan1">
                  <h4 class="text-center py-5">1 - BLOK</h4>
                  <div>
                    Fan nomi: <b>{{ examResult.fan1 }}</b>
                  </div>
                  <div>
                    To'g'ri javoblar soni:
                    <b>{{ examResult.correctAnswerFan1 }}</b>
                  </div>
                  <div>
                    Ballar: <b>{{ examResult.totalBallFan1 }}</b>
                  </div>
                  <div>
                    Noto'g'ri javob berilgan savollar raqamlari:
                    <b>{{ examResult.errorAnswerNumbersFan1 }}</b>
                  </div>
                </div>

                <v-divider class="mt-4" v-if="examResult.fan1" />

                <div v-if="examResult.fan2">
                  <h4 class="text-center py-5">2 - BLOK</h4>
                  <div>
                    Fan nomi: <b>{{ examResult.fan2 }}</b>
                  </div>
                  <div>
                    To'g'ri javoblar soni:
                    <b>{{ examResult.correctAnswerFan2 }}</b>
                  </div>
                  <div>
                    Ballar: <b>{{ examResult.totalBallFan2 }}</b>
                  </div>
                  <div>
                    Noto'g'ri javob berilgan savollar raqamlari:
                    <b>{{ examResult.errorAnswerNumbersFan2 }}</b>
                  </div>
                </div>

                <v-divider class="mt-4" v-if="examResult.fan2" />

                <div v-if="examResult.fan3">
                  <h4 class="text-center py-5">3 - BLOK</h4>
                  <div>
                    Fan nomi: <b>{{ examResult.fan3 }}</b>
                  </div>
                  <div>
                    To'g'ri javoblar soni:
                    <b>{{ examResult.correctAnswerFan3 }}</b>
                  </div>
                  <div>
                    Ballar: <b>{{ examResult.totalBallFan3 }}</b>
                  </div>
                  <div>
                    Noto'g'ri javob berilgan savollar raqamlari:
                    <b>{{ examResult.errorAnswerNumbersFan3 }}</b>
                  </div>
                </div>

                <v-divider class="mt-4" v-if="examResult.fan3" />

                <div class="pt-4" v-if="examResult.lgotBall">
                  Ijodiy imtihon yoki chet tili bo'yicha imtiyoz ballari:
                  <b>{{ examResult.lgotBall }}</b>
                </div>

                <v-divider class="mt-4" />

                <h4 class="text-center py-5">
                  TANLOVDA ISHTIROK ETISH UCHUN TANLAGAN TA'LIM YO'NALISHLAR
                  NOMI VA O'TISH BALLARI
                </h4>

                <table collapsed class="table table-bordered">
                  <thead>
                    <tr>
                      <th width="30px">№</th>
                      <th>Tanlov ta'lim yo'nalishi nomi va o'tish balli</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="examResult.ballC1">
                      <td>1</td>
                      <td>{{ examResult.ballC1 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC2">
                      <td>2</td>
                      <td>{{ examResult.ballC2 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC3">
                      <td>3</td>
                      <td>{{ examResult.ballC3 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC4">
                      <td>4</td>
                      <td>{{ examResult.ballC4 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC5">
                      <td>5</td>
                      <td>{{ examResult.ballC5 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC6">
                      <td>6</td>
                      <td>{{ examResult.ballC6 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC7">
                      <td>7</td>
                      <td>{{ examResult.ballC7 }}</td>
                    </tr>

                    <tr v-if="examResult.ballC8">
                      <td>8</td>
                      <td>{{ examResult.ballC8 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="pl-lg-0">
            <div class="my-card">
              <img :src="answerPaperPicture" alt="" />
            </div>
          </v-col>
        </v-row>
      </div>

      <!--
      <div class="-wrap">
        <h4 class="text-center py-5">NOTO'G'RI JAVOB BERILGAN SAVOLLAR</h4>

        <img
          src="http://cabinet.ytit.uz/static/media/questions/3060294/3060294_16.jpg"
          alt=""
        />
      </div> -->
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
.-wrap {
  margin-top: 40px;
  margin-bottom: 40px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.my-card {
  padding: 5px 20px;
  height: 100%;
}

.table-bordered {
  border: 1px solid #eaeaea;
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
}
</style>
